import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Calls the API to fetch the calculated functionalizations whenever a load
 * request is dispatched. Context and lab records come from the request, resolved
 * by {@link loadForCurrentEntity}.
 */
export const executeLoad = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.load.request.observe().pipe(
      rxjs.switchMap(action => {
        const { context, spaceRecordIds } = action.data

        return plugin.api.get({ ...context, spaceRecordIds }).pipe(
          rxjs.takeUntil(
            rxjs.merge(
              plugin.collection.feature.actions.changeContext.observe(),
              feature.actions.loadForCurrentEntity.request.observe(),
            ),
          ),
          rxjs.map(response =>
            feature.actions.load.success
              .from(action)
              .create({ request: action.data, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error
                .from(action)
                .create({ error, request: action.data }),
            ),
          ),
        )
      }),
    ),
)
